<template>
  <div class="min-h-screen bg-blue-50">
    <header class="fixed top-0 left-0 right-0 h-16 bg-white/95 backdrop-blur-md shadow-sm z-[1001] border-b border-blue-100">
      <div class="h-full flex items-center justify-between max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 gap-3 text-left">
        <button
          type="button"
          @click="goBack"
          class="flex items-center justify-center h-9 w-9 rounded-full bg-blue-50 hover:bg-blue-100 text-blue-900 hover:text-blue-700 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-900 focus:ring-offset-2 shrink-0"
          aria-label="Back to Social Hub"
        >
          <span class="material-symbols-outlined text-2xl">arrow_back</span>
        </button>
        <div class="flex-1 min-w-0">
          <h1 class="font-semibold text-gray-900 truncate">Community Posts</h1>
          <p class="text-xs text-gray-500 truncate">Share and discuss with your university peers</p>
        </div>
      </div>
    </header>

    <!-- Main content -->
    <main class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pt-20 py-4 pb-24">
      <!-- Not Joined Message -->
      <div v-if="!hasJoinedSocials" class="bg-white rounded-lg shadow-sm border border-gray-100 p-8 text-center">
        <span class="material-symbols-outlined text-5xl text-blue-300 mb-4">diversity_3</span>
        <h2 class="text-xl font-semibold text-gray-900 mb-2">Join Social Hub to Create Posts</h2>
        <p class="text-gray-600 mb-6">
          Connect with students from your university, share experiences, and build your academic network.
        </p>
        <button 
          @click="$router.push('/socials')"
          class="px-6 py-2.5 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
        >
          Go to Social Hub
        </button>
      </div>

      <!-- Social Content (Only visible if joined) -->
      <div v-else>
        <!-- Create Post Form -->
        <create-post-form />
        
        <!-- Loading State -->
        <div v-if="postsLoading" class="flex flex-col items-center justify-center py-12">
          <div class="w-12 h-12 border-4 border-blue-200 border-t-blue-800 rounded-full animate-spin mb-4"></div>
          <p class="text-blue-800">Loading posts...</p>
        </div>
        
        <!-- No Posts State -->
        <div v-else-if="!sortedPosts.length" class="bg-white rounded-lg shadow-sm border border-gray-100 p-8 text-center">
          <span class="material-symbols-outlined text-5xl text-gray-300 mb-4">article</span>
          <h2 class="text-xl font-semibold text-gray-700 mb-2">No Posts Yet</h2>
          <p class="text-gray-500 mb-6">
            Be the first to share something with the community!
          </p>
        </div>
        
        <!-- Posts List -->
        <div v-else>
          <post-card 
            v-for="post in sortedPosts" 
            :key="post.id" 
            :post="post"
          />
        </div>
      </div>
    </main>
  </div>
  <BottomNav />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BottomNav from '@/components/common/BottomNav.vue';
import CreatePostForm from '@/components/socials/CreatePostForm.vue';
import PostCard from '@/components/socials/PostCard.vue';

export default {
  components: {
    BottomNav,
    CreatePostForm,
    PostCard
  },
  computed: {
    ...mapState(['profile', 'postsLoading']),
    ...mapGetters(['sortedPosts']),
    hasJoinedSocials() {
      return this.profile && this.profile.joinedSocials === true;
    }
  },
  methods: {
    goBack() {
      this.$router.push('/socials');
    }
  },
  mounted() {
    // Fetch posts on component mount
    this.$store.dispatch('fetchPosts');
  }
};
</script>

<style scoped>
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.animate-spin {
  animation: spin 1s linear infinite;
}
</style>
